module.exports = __webpack_public_path__ + "media/images/athletes/2820-19afd8aa91121d9fff5f7ec45e6a436e.png";